import { IUserMilestone } from '../../IUserMilestone';

export const RETAILER_HAS_SEEN_R2M_HEART_ICON_TOOLTIP =
  'RETAILER_HAS_SEEN_R2M_HEART_ICON_TOOLTIP' as IUserMilestone.RetailerMilestone;
